import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import DialogBox from "../../common/DialogBox";
import { getObjLength } from "../../helpers/utils";
import { PER_PAGE } from "../../helpers/constants";
import AdminAccountSettings from "./AdminAccountSettings";
import CommonAgentsAdminTable from "./CommonAgentsAdminTable";
import PlainAlertMessage from "../../common/PlainAlertMessage";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";
import { Loader } from "../../common/loader";

let columns = [
  {
    key: 1,
    label: "",
    id: "action",
    minWidth: 10,
  },
  {
    key: 2,
    label: "Sales Manager",
    id: "full_name",
  },
  {
    key: 3,
    label: "Office",
    id: "office_name",
  },

  {
    key: 4,
    label: "Email",
    id: "email",
  },
  {
    key: 5,
    label: "Phone number",
    id: "phone",
  },
  {
    key: 6,
    label: "Website",
    id: "website",
    copyIcon: true,
    alignProp: "left",
  },
];

const AdminOverview = ({
  base_route = "broker",
  isSalesManager = false,
  isAgentAdmin = false,
  isRepInAdmin = false,
  sm_tabData = {},
  isSuperAdmin = false,
  broker_data = {},
}) => {
  const dispatch = useDispatch();

  const [addAgentAdminsOverviewModalOpen, setAddAgentAdminsOverviewModalOpen] =
    useState(false);
  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
  });
  const [pageCount, setPageCount] = useState(0);
  const [isEditAgentOffice, setIsEditAgentOffice] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState({});

  const {
    createAdminLoader,
    agentAdminDetails,
    createAgentAdminDetails,
    salesRepresentativeList,
    agentRepLoader,
    isAddBtnClicked,
  } = useSelector((state) => state?.agentsAdmin);

  const openAgentAdminsOverviewModal = () => {
    setSelectedProperty();
    setAddAgentAdminsOverviewModalOpen(true);
  };
  const closeAgentAdminsOverviewModal = () => {
    setSelectedProperty();
    setIsEditAgentOffice(false);
    setAddAgentAdminsOverviewModalOpen(false);
    dispatch(agentsAdminAction.fetchCreateAgentAdminData({}));
    dispatch(agentsAdminAction.fetchIsAddBtnClicked(false));
  };

  const handleEditAdminModal = () => {
    setAddAgentAdminsOverviewModalOpen(true);
    setIsEditAgentOffice(true);
    dispatch(agentsAdminAction.fetchCreateAgentOfficeData({}));
  };

  const onFormSubmit = (values) => {
    let data = { ...values, skip_verification: 1 };
    delete data?.password;
    delete data?.old_password;
    delete data?.logo;
    if (isEditAgentOffice) {
      if (selectedProperty?.profile_img === data?.profile_img) {
        delete data?.profile_img;
      }
    }
    if (data?.profile_img?.length === 0 && !isEditAgentOffice) {
      delete data?.profile_img;
    }
    if (isRepInAdmin) {
      data = { ...data, by_admin: true };
    }
    if (isSuperAdmin) {
      delete data.by_admin;
      data = { ...data, from_super_admin: true, broker_id: broker_data?.id };
    }
    console.log("Values...", data);
    let url = `broker/create-sales-manager?source=${base_route}`;
    let sm_url = `sales-manager/representative/create?source=${base_route}`;
    if (isRepInAdmin) {
      sm_url = `broker/representative/create?source=${base_route}`;
    }
    if (isEditAgentOffice) {
      url = `broker/update-sales-manager/${selectedProperty?.id}?source=${base_route}`;
      sm_url = `sales-manager/representative/edit/${selectedProperty?.id}?source=${base_route}`;
      if (isRepInAdmin) {
        sm_url = `broker/representative/edit/${selectedProperty?.id}?source=${base_route}`;
      }
    }
    dispatch(
      agentsAdminAction.createAgentAdminDetails({
        url: isSalesManager ? sm_url : url,
        data,
        brokertoken: !isSuperAdmin,
        token: isSuperAdmin,
      })
    );
  };

  const agentAdminsOverviewListAPICall = useCallback(() => {
    let data = {
      limit: payload?.limit,
      offset: payload?.offset,
    };
    let url = `broker/get-sales-managers?source=${base_route}`;
    if (isSalesManager) {
      url = `sales-manager/representative/list?source=${base_route}`;
      dispatch(agentsAdminAction.goToRepresentativeTab(false));
      if (isRepInAdmin) {
        url = `broker/representative/list?source=${base_route}`;
        data = { ...data, by_admin: true };
      }
    }
    if (isSuperAdmin) {
      delete data?.by_admin;
      data = { ...data, from_super_admin: true, broker_id: broker_data?.id };
    }
    if (!isRepInAdmin) {
      dispatch(
        agentsAdminAction.getAgentAdminDetails({
          url,
          data,
          brokertoken: !isSuperAdmin,
          token: isSuperAdmin,
        })
      );
    } else {
      dispatch(
        agentsAdminAction.getSalesRepresentativeDetails({
          url,
          data,
          brokertoken: !isSuperAdmin,
          token: isSuperAdmin,
        })
      );
    }
    window.scrollTo(0, 0);
  }, [dispatch, payload?.limit, payload?.offset]);

  useEffect(() => {
    agentAdminsOverviewListAPICall();
  }, [agentAdminsOverviewListAPICall]);

  useEffect(() => {
    if (getObjLength(agentAdminDetails)) {
      if (agentAdminDetails?.success) {
        setPageCount(Math.ceil(agentAdminDetails?.count / PER_PAGE));
        if (agentAdminDetails?.count === 10) {
          setPayload((prevState) => ({
            ...prevState,
            offset: 0,
          }));
        }
      }
    }
  }, [agentAdminDetails]);

  useEffect(() => {
    if (getObjLength(salesRepresentativeList) && isRepInAdmin) {
      if (salesRepresentativeList?.success) {
        setPageCount(Math.ceil(salesRepresentativeList?.count / PER_PAGE));
        if (salesRepresentativeList?.count === 10) {
          setPayload((prevState) => ({
            ...prevState,
            offset: 0,
          }));
        }
      }
    }
  }, [salesRepresentativeList]);

  useEffect(() => {
    if (isAddBtnClicked) {
      openAgentAdminsOverviewModal();
    }
  }, [isAddBtnClicked]);

  useEffect(() => {
    if (isSuperAdmin) {
      if (!columns.find((e) => e.key === 7)) {
        columns.push({
          key: 7,
          label: "Action",
          id: "action",
          minWidth: 10,
        });
      }
      columns.forEach((col) => {
        if (col.key === 1) {
          col.id = "sr";
          col.label = "No.";
        }
      });
      columns.sort(function (a, b) {
        return a.key - b.key;
      });
    } else {
      // columns.forEach((col) => {
      //   if (col.id === "website") {
      //     col.copyIcon = false;
      //     col.alignProp = "left";
      //   }
      // });
    }
  }, [isSuperAdmin]);

  const rowData = isRepInAdmin
    ? salesRepresentativeList?.success
      ? salesRepresentativeList?.data
      : []
    : agentAdminDetails?.success
    ? agentAdminDetails?.data
    : [];

  return (
    <div>
      <CommonAgentsAdminTable
        columns={isSalesManager ? sm_tabData?.sm_columns : columns}
        btn_texts={
          isSalesManager ? sm_tabData?.sm_btn_texts : "Add Sales Manager"
        }
        rowData={rowData || []}
        addBtnClick={openAgentAdminsOverviewModal}
        pageCount={pageCount}
        setPageCount={setPageCount}
        setPayload={setPayload}
        payload={payload}
        setEditRecord={handleEditAdminModal}
        setSelectedProperty={setSelectedProperty}
        selectedPropertyID={selectedProperty?.id}
        deleteAPIURL={
          isSalesManager && !isRepInAdmin
            ? "sales-manager/representative/delete"
            : isRepInAdmin
            ? "broker/representative/delete"
            : "broker/delete-sales-manager"
        }
        customeDeleteMessage={`Are you sure you want to delete this ${
          isSalesManager
            ? "Sales Representative"
            : isAgentAdmin
            ? "Sales Manager"
            : "Office"
        }? This action can not be undone.`}
        listAPICall={agentAdminsOverviewListAPICall}
        base_route={base_route}
        isSuperAdmin={isSuperAdmin}
      />
      {/* Add Office form modal */}
      {addAgentAdminsOverviewModalOpen && (
        <DialogBox
          dividers
          width={
            getObjLength(createAgentAdminDetails) &&
            createAgentAdminDetails?.success
              ? "sm"
              : "lg"
          }
          title={
            (!getObjLength(createAgentAdminDetails) ||
              !createAgentAdminDetails?.success) &&
            `${isEditAgentOffice ? "Edit" : "Add"} Sales ${
              isSalesManager ? "Representative" : "Manager"
            }`
          }
          contentClassName={"bg-white p-0"}
          openPopup={addAgentAdminsOverviewModalOpen}
          setOpenPopup={setAddAgentAdminsOverviewModalOpen}
          onClose={
            getObjLength(createAgentAdminDetails) &&
            createAgentAdminDetails?.success
              ? false
              : closeAgentAdminsOverviewModal
          }
          content={
            !getObjLength(createAgentAdminDetails) ||
            !createAgentAdminDetails?.success ? (
              <>
                <AdminAccountSettings
                  closeAgentAdminsModal={closeAgentAdminsOverviewModal}
                  onFormSubmit={onFormSubmit}
                  isEdit={isEditAgentOffice}
                  selectedProperty={selectedProperty}
                  isSalesManager={isSalesManager}
                  isRepInAdmin={isRepInAdmin}
                  isAgentAdmin={isAgentAdmin}
                  isSuperAdmin={isSuperAdmin}
                />
              </>
            ) : (
              <PlainAlertMessage
                type="Success"
                openPopup={true}
                onClose={true}
                onCloseFun={() => {
                  agentAdminsOverviewListAPICall();
                  closeAgentAdminsOverviewModal();
                }}
                message={createAgentAdminDetails?.message}
                footer={false}
              />
            )
          }
        />
      )}
      <Loader open={createAdminLoader || agentRepLoader} />
    </div>
  );
};

export default AdminOverview;
